import { ButtonGhost, ButtonSolid } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const OrderSuccesButton = {
  ButtonWrapper: styled('div')`
    display: grid;
    grid-gap: ${theme.space[4]};
    width: 100%;

    &[data-margin-top='sp-6'] {
      margin-top: ${theme.space[6]};
    }

    &[data-margin-bottom='sp-4'] {
      margin-bottom: ${theme.space[4]};
    }
  `,

  ButtonSolid: styled(ButtonSolid)`
    align-items: center;
    background: ${theme.colors.action.navigation.standard.static};
    color: ${theme.colors.build.lightLight};
    display: flex;
    justify-content: center;
  `,

  ButtonGhost: styled(ButtonGhost)`
    align-items: center;
    color: ${theme.colors.action.navigation.standard.static};
    display: flex;
    justify-content: center;
  `,
};
